import get from "lodash.get";
import Config from "./config";
import AuthenticationUtils from "services/authentication/utils";
import { applicationStore } from "store";

import AuthenticationActioner from "services/authentication/actioner";

// Inject X-Access-Token in headers only if X-Refresh-Token is absent
const getTokenHeaders = async (params) => {
  return new Promise(async (resolve, reject) => {
    if (params.noAuth) {
      return resolve({});
    }
    if (params && params.headers && params.headers["X-Refresh-Token"]) {
      return resolve({ "X-Refresh-Token": params.headers["X-Refresh-Token"] });
    }
    if (params && params.headers && params.headers["X-Confirm-Token"]) {
      return resolve({ "X-Confirm-Token": params.headers["X-Confirm-Token"] });
    }

    const accessToken = await AuthenticationUtils.getAccessToken();

    return resolve({
      "X-Access-Token": `${accessToken}`,
    });
  });
};
let httpCalls = {};

const XHTTP = async (endPoint, paramsFromArgs) => {
  const params = {
    abortMultiple: true,
    ...paramsFromArgs,
  };
  if (get(params, "abortMultiple") && get(httpCalls, endPoint))
    get(httpCalls, endPoint).abort();

  // We store an instance of every request. If the same request is sent, the first one we'll be cancelled
  // Warning: At the moment, we have choosen to cancel every double request. If one day, we make volontary
  //          two times the same request, the first one is gonna be cancelled. Maybe exclude some request in the future ?
  const abortController = new AbortController();
  httpCalls = {
    ...httpCalls,
    [endPoint]: abortController,
  };
  const tokenHeaders = await getTokenHeaders(params);

  return new Promise((resolve, reject) => {
    const fullUrl = `${Config.hosts.apiHost}${endPoint}`;

    fetch(fullUrl, {
      ...params,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...tokenHeaders,
        ...params.header,
      },
      signal: abortController.signal,
    })
      .then((response) => {
        if (response.status < 400) {
          // if status equal 204 there are no content to return
          if (response.status === 204) {
            return resolve();
          }
          return response.json().then(resolve).catch(reject);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        if (error?.name === "AbortError") {
          return true;
        }

        if (typeof error?.json === "function") {
          error.json().then((jsonError) => {
            if (error?.status === 422 && jsonError?.error === "TokenExpired") {
              return applicationStore.dispatch(AuthenticationActioner.logout());
            }
          });
        }

        return reject(error);
      })
      .finally(() => {
        httpCalls = {
          ...httpCalls,
          [endPoint]: undefined,
        };
      });
  });
};

export const XHTTPBlob = async (endPoint, paramsFromArgs) => {
  const params = {
    abortMultiple: true,
    ...paramsFromArgs,
  };
  if (get(params, "abortMultiple") && get(httpCalls, endPoint))
    get(httpCalls, endPoint).abort();

  // We store an instance of every request. If the same request is sent, the first one we'll be cancelled
  // Warning: At the moment, we have choosen to cancel every double request. If one day, we make volontary
  //          two times the same request, the first one is gonna be cancelled. Maybe exclude some request in the future ?
  const abortController = new AbortController();
  httpCalls = {
    ...httpCalls,
    [endPoint]: abortController,
  };
  const tokenHeaders = await getTokenHeaders(params);

  return new Promise((resolve, reject) => {
    const fullUrl = `${Config.hosts.apiHost}${endPoint}`;

    fetch(fullUrl, {
      ...params,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...tokenHeaders,
        ...params.header,
      },
      signal: abortController.signal,
    })
      .then((response) => {
        if (response.status < 400) {
          // if status equal 204 there are no content to return
          if (response.status === 204) {
            return resolve();
          }
          return response.blob().then(resolve).catch(reject);
        }
        return Promise.reject(response);
      })
      .catch((error) => {
        if (error?.name === "AbortError") {
          return true;
        }

        if (typeof error?.json === "function") {
          error.json().then((jsonError) => {
            if (error?.status === 422 && jsonError?.error === "TokenExpired") {
              return applicationStore.dispatch(AuthenticationActioner.logout());
            }
          });
        }

        return reject(error);
      })
      .finally(() => {
        httpCalls = {
          ...httpCalls,
          [endPoint]: undefined,
        };
      });
  });
};
export default XHTTP;
